import { Toaster } from "@nu-art/toasting";
import { Second } from "@nu-art/ts-common";
export const ToastKey_AdvisorGeneral = 'advisor-general';
export const Toaster_AdvisorGeneral = new Toaster(ToastKey_AdvisorGeneral, 2 * Second);
export const ToastFilter_AdvisorGeneral = (model) => model.key === ToastKey_AdvisorGeneral;
//# sourceMappingURL=toast.js.map